import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { hideModal } from '../../actions/modal/modal';
import { resetPassword } from '../../actions/app/app';

const RecoverAccountForm = props => {

  const dispatch = useDispatch(),
        appProps = useSelector(store => store.app),
        formik = useFormik({
          initialValues: {
            email: ''
          },
          validationSchema: Yup.object({
            email: Yup.string().email('Email address doesn\'t seem to be formatted correctly.').required('Email address is required')
          }),
          onSubmit: values => {
            dispatch(resetPassword(JSON.stringify({ email: values.email })));
          }
        });

  return (
    <>
      <span className="modal__close" onClick={ () => dispatch(hideModal()) }>&times;</span>
      
      <form onSubmit={ formik.handleSubmit } className="form form--restricted">
        <p className="form__text">Enter your email below to receive a link to reset your password.</p>

        <div className="form__group">
          <input className="form__input" type="email" name="email" id="email" onChange={ formik.handleChange } onBlur={ formik.handleBlur } placeholder="Enter your email address" />
          { formik.touched.email &&  formik.errors.email ? (<span className="form__error-item">{ formik.errors.email }</span>) : ''}
        </div>
        
        <button type="submit" className="form__button button" disabled={ appProps.loading || !formik.dirty }>Recover account</button>

        <p className="form__help-text">Remembered your details? <span className="form__help-link" onClick={ props.signInEvent }>Sign in!</span></p>
        <p className="form__help-text">Don't have an account? <span className="form__help-link" onClick={ props.signUpEvent }>Sign up!</span></p>
      </form>
    </>
  );

}

export default RecoverAccountForm;